import React, { ReactNode } from 'react';
import useCarousel from '../../core/hooks/use-carousel';
import { SectionHeaderTitle } from '../section-header-title/section-header-title';
import { SectionHeaderCarousel } from '../section-header-carousel/section-header-carousel';
import styles from './teaser-card-layout.module.scss';

type Props = {
  sectionTitle: string;
  children: ReactNode;
  variant?: 'grid' | 'carousel';
};

const TeaserCardGridLayoutGrid: React.FC<Props> = ({ sectionTitle, children }) => {
  return (
    <div className={styles.root}>
      <SectionHeaderTitle>{sectionTitle}</SectionHeaderTitle>
      <div className={styles.grid}>{children}</div>
    </div>
  );
};

const TeaserCardGridLayoutCarousel: React.FC<Props> = ({ sectionTitle, children }) => {
  const { scrollPosition, carouselScrollContainerRef, next, prev } = useCarousel(
    React.Children.count(children),
    `.${styles.carousel} > *`,
  );

  return (
    <div className={styles.root}>
      <SectionHeaderCarousel scrollPosition={scrollPosition} onNext={next} onPrev={prev}>
        {sectionTitle}
      </SectionHeaderCarousel>
      <div ref={carouselScrollContainerRef} className={styles.carousel}>
        {children}
      </div>
    </div>
  );
};

export const TeaserCardLayout: React.FC<Props> = ({ variant = 'grid', ...props }) => {
  switch (variant) {
    case 'grid':
      return <TeaserCardGridLayoutGrid {...props} />;
    case 'carousel':
      return <TeaserCardGridLayoutCarousel {...props} />;
    default:
      return null;
  }
};
